import { createApp } from 'vue';
import App from './App.vue';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

import { BootstrapVue3 } from 'bootstrap-vue-3';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import store from './store';

import { FontAwesomeIcon } from './plugins/fontawesome';

const vuetify = createVuetify({
  components,
  directives,
});
createApp(App)
  .use(vuetify)
  .use(BootstrapVue3)
  .use(ElementPlus)
  .use(store)
  .component('font-awesome-icon', FontAwesomeIcon) 
  .mount('#app');
